<section class="security-page">
  <header class="security-heading">
    <span class="security-icon"><img src="assets/media/svg/autenticacion-dos-pasos.svg" alt="" width="48" height="48"></span>
    <div>
      <h1>Autenticación En Dos Pasos</h1>
      <nav aria-label="Ruta de navegación"><a routerLink="/dashboard">Portal Defontana</a><span> / </span><a routerLink="/dashboard">Dashboard</a><span> / </span><span aria-current="page">Autenticación En Dos Pasos</span></nav>
    </div>
  </header>
  <p class="security-subtitle">Agrega una capa adicional de seguridad al iniciar sesión.</p>
  <div class="security-table-card" [attr.aria-busy]="appStateService.loading">
    <div class="security-table-scroll">
      <table mat-table [dataSource]="appStateService.ListTwoFactorByUserResult && appStateService.ListTwoFactorByUserResult.twoFactorList || []" aria-label="Métodos de autenticación en dos pasos">
        <ng-container matColumnDef="col1">
          <th mat-header-cell *matHeaderCellDef>Método de autenticación</th>
          <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>
        <ng-container matColumnDef="col2">
          <th mat-header-cell *matHeaderCellDef>Descripción</th>
          <td mat-cell *matCellDef="let element">{{methodDescription(element.code)}}</td>
        </ng-container>
        <ng-container matColumnDef="col3">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element"><span class="status-badge" [class.active]="element.active">{{element.active ? 'Activado' : 'Desactivado'}}</span></td>
        </ng-container>
        <ng-container matColumnDef="col4">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let element">
            <mat-slide-toggle [checked]="element.active" [disabled]="appStateService.loading" [aria-label]="'Activar o desactivar ' + element.name" (change)="slideChanged(element, $event)"></mat-slide-toggle>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr *matNoDataRow><td colspan="4" class="security-empty" role="status">{{appStateService.loading ? 'Cargando métodos de autenticación…' : 'No hay métodos de autenticación disponibles.'}}</td></tr>
      </table>
    </div>
  </div>
</section>
